import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  name: "coupon",
  data: function data() {
    return {
      orderTypeList: [{
        name: '待使用',
        count: 0
      }, {
        name: '已使用',
        count: 0
      }, {
        name: '已过期',
        count: 0
      }],
      activeIdx: 0,
      couponList: [],
      total: null,
      current: 1,
      // 页码
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      allMoeny: 0
    };
  },
  created: function created() {
    this.getCoupon(1);
  },
  methods: {
    changeOrder: function changeOrder(idx) {
      this.activeIdx = idx;
      this.couponList = [];
      this.current = 1;
      this.getCoupon(idx + 1);
      console.log(this.activeIdx);
    },
    //分页
    handleChange: function handleChange(val) {
      this.current = val;
      this.getCoupon(this.activeIdx + 1);
    },
    //获取列表
    getCoupon: function getCoupon(val) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$getHttpClient().post("/pjyy-deepexi-coupon-center/api/v1/queryCouponAllByCustomerCode", {
                couponStatus: val,
                page: _this.current,
                pageSize: _this.perPage
              });
            case 2:
              res = _context.sent;
              if (res.data.code == 200) {
                _this.total = res.data.data.total;
                _this.perPage = res.data.data.pageSize;
                _this.orderTypeList[0].count = res.data.data.list[0].unUsedCount;
                _this.orderTypeList[1].count = res.data.data.list[0].usedCount;
                _this.orderTypeList[2].count = res.data.data.list[0].overdueCount;
                _this.allMoeny = res.data.data.list[0].countPrice;
                _this.couponList = res.data.data.list[0].couponListVO;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //立即使用
    nowUse: function nowUse() {
      this.$router.push({
        path: "/channel/channel-detail/" + "0/0"
      });
    }
  }
};